import React, { useEffect, useState } from "react";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "reachforge.cookie-consent";

export default function CookieBanner() {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        try {
            const saved = localStorage.getItem(STORAGE_KEY);
            if (!saved) {
                // Slight delay so it doesn't fight first-paint animations
                const t = setTimeout(() => setOpen(true), 800);
                return () => clearTimeout(t);
            }
        } catch (_) {
            setOpen(true);
        }
    }, []);

    const decide = (choice) => {
        try {
            localStorage.setItem(
                STORAGE_KEY,
                JSON.stringify({ choice, ts: Date.now() }),
            );
        } catch (_) {
            /* ignore */
        }
        setOpen(false);
    };

    if (!open) return null;

    return (
        <div
            data-testid="cookie-banner"
            role="dialog"
            aria-label="Cookie consent"
            className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-[480px] z-[60] fade-up"
        >
            <div className="bg-bg border border-ink shadow-[6px_6px_0_0_hsl(var(--ink))] p-5 md:p-6">
                <div className="flex items-start gap-4">
                    <div className="hidden sm:flex h-10 w-10 border border-ink items-center justify-center shrink-0">
                        <Cookie size={18} strokeWidth={2.25} />
                    </div>
                    <div className="flex-1">
                        <div className="flex items-start justify-between gap-3">
                            <span className="overline">Cookies</span>
                            <button
                                onClick={() => decide("dismissed")}
                                data-testid="cookie-dismiss"
                                aria-label="Dismiss"
                                className="h-6 w-6 flex items-center justify-center text-ink-mute hover:text-ink transition-colors"
                            >
                                <X size={14} />
                            </button>
                        </div>
                        <p className="mt-2 text-sm text-ink leading-relaxed">
                            We use a tiny set of cookies for analytics and to
                            remember your preferences. No third-party ad
                            trackers, ever.
                        </p>
                        <div className="mt-4 flex flex-wrap gap-2">
                            <button
                                data-testid="cookie-accept"
                                onClick={() => decide("accepted")}
                                className="btn btn-primary h-10 px-4 text-xs"
                            >
                                Accept all
                            </button>
                            <button
                                data-testid="cookie-essential"
                                onClick={() => decide("essential")}
                                className="btn btn-secondary h-10 px-4 text-xs"
                            >
                                Essential only
                            </button>
                            <a
                                href="#"
                                data-testid="cookie-policy-link"
                                className="text-xs text-ink-soft hover:text-ink link-underline self-center ml-1"
                            >
                                Cookie policy
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
